(()=>{"use strict";const q=(s,c=document)=>c.querySelector(s),qa=(s,c=document)=>[...c.querySelectorAll(s)];document.addEventListener("click",e=>{const o=e.target.closest("[data-hol-filter-open]"),c=e.target.closest("[data-hol-filter-close]"),v=e.target.closest("[data-grid-view]");if(o){const d=document.getElementById(o.getAttribute("aria-controls"));if(d){d.hidden=false;o.setAttribute("aria-expanded","true");document.documentElement.style.overflow="hidden";q(".hol-filter__panel",d)?.focus()}}if(c){const d=c.closest("[data-hol-filter]");if(d){d.hidden=true;document.documentElement.style.overflow="";document.querySelector(`[aria-controls="${d.id}"]`)?.setAttribute("aria-expanded","false")}}if(v){const r=v.closest("[data-hol-collection]");if(!r)return;qa("[data-grid-view]",r).forEach(b=>b.classList.toggle("is-active",b===v));qa(".hol-card",r).forEach(card=>{qa(".hol-card__image",card).forEach(i=>i.classList.remove("is-active"));q(`.hol-card__image--${v.dataset.gridView}`,card)?.classList.add("is-active")})}});document.addEventListener("keydown",e=>{if(e.key==="Escape"){const d=q("[data-hol-filter]:not([hidden])");if(d){d.hidden=true;document.documentElement.style.overflow=""}}})})();
document.addEventListener("cart:updated",function(e){
  var wrap=document.querySelector("[data-hol-shipping-progress]"); if(!wrap)return;
  var cart=(e.detail&&e.detail.cart)||e.detail||null; if(!cart||typeof cart.total_price!=="number")return;
  var threshold=Number(wrap.dataset.threshold||100000), remaining=Math.max(0,threshold-cart.total_price);
  var copy=wrap.querySelector("[data-hol-shipping-copy]"),bar=wrap.querySelector("[data-hol-shipping-bar]");
  if(copy) copy.textContent=remaining>0 ? ((remaining/100).toLocaleString(undefined,{style:"currency",currency:"ZAR"})+" UNTIL COMPLIMENTARY DELIVERY") : "COMPLIMENTARY DELIVERY UNLOCKED";
  if(bar) bar.style.width=Math.min(100,(cart.total_price/threshold)*100)+"%";
});

(function(){
  "use strict";
  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const setOpen=(el,open,trigger)=>{
    if(!el)return;
    el.hidden=!open;
    document.body.classList.toggle("hol-overlay-open",open);
    if(trigger) trigger.setAttribute("aria-expanded",open?"true":"false");
    if(open) setTimeout(()=>el.querySelector('[tabindex="-1"],input,button,a')?.focus(),0);
  };
  document.addEventListener("click",e=>{
    let b=e.target.closest("[data-hol-menu-open]"); if(b){setOpen($("#HOLMegaMenu"),true,b);return}
    b=e.target.closest("[data-hol-menu-close]"); if(b){setOpen($("#HOLMegaMenu"),false,$('[data-hol-menu-open]'));return}
    b=e.target.closest("[data-hol-search-open]"); if(b){setOpen($("#HOLSearch"),true,b);setTimeout(()=>$("#HOLSearchInput")?.focus(),10);return}
    b=e.target.closest("[data-hol-search-close]"); if(b){setOpen($("#HOLSearch"),false,$('[data-hol-search-open]'));return}
    b=e.target.closest("[data-hol-mobile-add]"); if(b){const real=$("[data-section-type='product-template'] [data-add-to-cart]");if(real&&!real.disabled)real.click();}
  });
  document.addEventListener("keydown",e=>{if(e.key==="Escape"){if(!$("#HOLSearch")?.hidden)setOpen($("#HOLSearch"),false,$('[data-hol-search-open]'));else if(!$("#HOLMegaMenu")?.hidden)setOpen($("#HOLMegaMenu"),false,$('[data-hol-menu-open]'));}});
  $$("[data-hol-localization]").forEach(sel=>sel.addEventListener("change",()=>sel.form?.submit()));

  const input=$("[data-hol-search-input]"), results=$("[data-hol-search-results]"), intro=$("[data-hol-search-intro]");
  let timer;
  const esc=s=>String(s??"").replace(/[&<>"']/g,m=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"}[m]));
  if(input&&results){
    input.addEventListener("input",()=>{
      clearTimeout(timer); const q=input.value.trim();
      if(q.length<2){results.innerHTML="";if(intro)intro.hidden=false;return}
      timer=setTimeout(async()=>{
        try{
          const url=`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
          const res=await fetch(url,{headers:{"Accept":"application/json"}});
          if(!res.ok)throw new Error("search");
          const data=await res.json(), products=data?.resources?.results?.products||[];
          if(intro)intro.hidden=true;
          results.innerHTML=products.length?products.map(p=>`<a class="hol-search-card" href="${esc(p.url)}"><div class="hol-search-card__media">${p.image?`<img src="${esc(p.image)}&width=700" alt="${esc(p.title)}" loading="lazy">`:""}</div><div class="hol-search-card__copy"><span>${esc(p.title)}</span><span>${esc(p.price)}</span></div></a>`).join(""):`<p style="padding:18px">NO PRODUCTS FOUND.</p>`;
        }catch(err){results.innerHTML=`<p style="padding:18px">SEARCH UNAVAILABLE. PRESS ENTER TO VIEW RESULTS.</p>`}
      },180);
    });
  }

  const buybar=$("[data-hol-mobile-buybar]"), form=$("[data-section-type='product-template'] form.product-single__form"), realBtn=form?.querySelector("[data-add-to-cart]");
  if(buybar&&form&&realBtn){
    const update=()=>{
      const rect=realBtn.getBoundingClientRect();
      buybar.classList.toggle("is-visible",rect.bottom<0);
      const realText=realBtn.querySelector("[data-add-to-cart-text]")?.textContent?.trim();
      const mobile=buybar.querySelector("[data-hol-mobile-add]");
      if(mobile){mobile.disabled=realBtn.disabled;mobile.textContent=realText||"ADD TO BAG";}
      const selected=form.querySelector('[name="id"] option:checked, [name="id"]');
      if(selected&&selected.dataset&&selected.dataset.price) buybar.querySelector("[data-hol-mobile-price]").textContent=selected.dataset.price;
    };
    document.addEventListener("scroll",update,{passive:true});document.addEventListener("change",e=>{if(form.contains(e.target))setTimeout(update,40)});update();
  }
})();

(function(){
  "use strict";
  document.querySelectorAll("[data-hol-rail]").forEach(rail=>{
    rail.querySelectorAll("[data-rail-view]").forEach(btn=>btn.addEventListener("click",()=>{
      const view=btn.dataset.railView;
      rail.querySelectorAll("[data-rail-view]").forEach(x=>x.classList.toggle("is-active",x===btn));
      rail.querySelectorAll(".hol-rail-card").forEach(card=>{
        card.querySelectorAll(".hol-rail-card__img").forEach(img=>img.classList.toggle("is-active",img.classList.contains(`hol-rail-card__img--${view}`)));
      });
    }));
  });

  document.addEventListener("click",e=>{
    const fit=e.target.closest("[data-hol-fit-open]");
    if(fit){const note=fit.nextElementSibling;if(note&&note.hasAttribute("data-hol-fit-note"))note.hidden=!note.hidden;}
  });

  const formatMoney=(cents)=>{
    try{return new Intl.NumberFormat(document.documentElement.lang||"en-ZA",{style:"currency",currency:"ZAR",maximumFractionDigits:2}).format(cents/100)}
    catch(e){return "R"+(cents/100).toFixed(2)}
  };
  document.querySelectorAll("[data-hol-uniform]").forEach(uniform=>{
    const selects=Array.from(uniform.querySelectorAll("[data-uniform-variant]"));
    const total=uniform.querySelector("[data-uniform-total]"), message=uniform.querySelector("[data-uniform-message]"), add=uniform.querySelector("[data-uniform-add]");
    const update=()=>{
      let sum=0,complete=selects.length>0;
      selects.forEach(s=>{const o=s.options[s.selectedIndex];if(!s.value)complete=false;else sum+=Number(o?.dataset?.price||0)});
      if(total)total.textContent=complete?formatMoney(sum):"SELECT ALL SIZES";
    };
    selects.forEach(s=>s.addEventListener("change",update));update();
    add?.addEventListener("click",async()=>{
      const items=selects.filter(s=>s.value).map(s=>({id:Number(s.value),quantity:1}));
      if(items.length!==selects.length){if(message)message.textContent="SELECT A SIZE FOR EACH PIECE.";return}
      add.disabled=true;if(message)message.textContent="ADDING LOOK…";
      try{
        const res=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items})});
        if(!res.ok)throw new Error("cart");
        if(message)message.textContent="LOOK ADDED TO BAG.";
        document.dispatchEvent(new CustomEvent("cart:updated"));
        setTimeout(()=>document.querySelector(".js-drawer-open-cart")?.click(),150);
      }catch(err){if(message)message.textContent="ONE OR MORE PIECES COULD NOT BE ADDED. PLEASE TRY AGAIN."}
      finally{add.disabled=false}
    });
  });
})();
